import React, { Fragment, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { OrganizationNameField } from './OrganizationDetailsFields';

export interface DetailsOrganizationForm {
  [propName: string]: object;
}

const OrganizationDetailsForm = (): ReactElement | null => {
  const { t } = useTranslation('EditOrganizationStep');

  return (
    <Fragment>
      <OrganizationNameField autoFocus label="Organization Name" name="name" t={t} />
    </Fragment>
  );
};

export default OrganizationDetailsForm;
